module.exports = __webpack_public_path__ + "img/es_text.13b06d72.svg";